// @flow

const numeral = require('numeral');

const toolHelper = {

  // Capslock detection
  isCapslock: (e: any) => {
    if( !e ) return false;

    var s = e.key;
    if( s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey ) {
      return true;
    }

    return false;
  },

  formatNumber: (value: string) => {
    if( toolHelper.isFloat(value) || toolHelper.isInt(value) ) {
      return value;
    } else {
      if( value === undefined || value === null ) return 0;
      return (toolHelper.safeNumberFormat(value));
    }
  },

  safeNumberFormat: (number: string) => {
    var countDots = (number.toString().match(RegExp('\\.','g')) || []).length;
    if( countDots > 1 ) {
      // This means that dot is used for thousand seperator
      number = number.toString().replace(/\./g,'');
      number = number.toString().replace(",", ".");
    }

    var countCommas = (number.toString().match(RegExp('\\,','g')) || []).length;
    if( countCommas > 1 ) {
      // This means that comma is used for thousand seperator
      number = number.toString().replace(/,/g,'');
    }

    let safeNum = numeral(number).format('0.0');
    return safeNum;
  },

  isInt: (n: any) => {
    return Number(n) === n && n % 1 === 0;
  },

  isFloat: (n: any) => {
    return Number(n) === n && n % 1 !== 0;
  },

  // Remove duplicate keys in array
  remove_duplicates_safe: (arr: any) => {
    var seen    = {};
    var ret_arr = [];
    for (var i = 0; i < arr.length; i++) {
      if (!(arr[i] in seen)) {
        ret_arr.push(arr[i]);
        ret_arr[arr[i]] = [];
        seen[arr[i]] = true;
      }
    }

    return ret_arr;
  },

  // Check for HTTP(S) and return whole URL
  fix_https_url: (value: string) => {
    if ( !/^(f|ht)tps?:\/\//i.test(value) ) {
      return "http://" + value;
    }
    return value;
  },

  // Retrieve whole domain from url
  retrieve_domain_url: (url: string = '') => {
    var hostname;

    //find & remove protocol (http, ftp, etc.) and get hostname
    if (url.indexOf("://") > -1) {
      hostname = url.split('/')[2];
    }
    else {
      hostname = url.split('/')[0];
    }

    //find & remove port number
    hostname = hostname.split(':')[0];
    //find & remove "?"
    hostname = hostname.split('?')[0];

    return hostname;
  },

  // Create SEO from text
  create_seo: (value: string) => {
    var encodedUrl = value.toString().toLowerCase();
    encodedUrl = encodedUrl.split(/&+/).join("-and-")
    encodedUrl = encodedUrl.split(/[^a-z0-9]/).join("_");
    encodedUrl = encodedUrl.split(/-+/).join("_");
    encodedUrl = encodedUrl.trim();
    return encodedUrl;
  },

  // Get extension from string
  get_file_ext: (value: string = '') => {
    if( value === '' ) return value;
    let regex = /(?:\.([^.]+))?$/;
    return regex.exec(value)[1];
  },

  // Get file name safe
  get_file_name_safe: (value: string = '') => {
    if( value === '' ) return value;
    return value.replace(/ /g, "_").replace(/[^a-zA-Z0-9\s_]/g, '');
  }

}

export default toolHelper;



// WEBPACK FOOTER //
// ./src/helpers/tools.helper.js